import React, {useEffect, useState} from 'react';
import './ThoughtDragReview.sass';
import _ from "lodash"
import {gsap} from "gsap"
import StandardButton from "../../ui/Button/StandardButton";

const ThoughtDragReview = ({choices, selected, completed}) => {

    const [counter, setCounter] = useState(0);
    const [currentChoice, setCurrentChoice] = useState(null)
    const [choiceReviewComplete, setChoiceReviewComplete] = useState(false)
    const [showTable, setShowTable] = useState(false)

    useEffect(() => {
        if (counter === selected.length) {
            setCurrentChoice(null)
            setShowTable(true);
        } else {
            let c = _.find(choices, {"id": selected[counter]});
            setCurrentChoice(c)
        }
    }, [counter])

    useEffect(() => {
        gsap.from("#thought-bar", {x: -1400, ease: "expo.out",delay:.5});
        gsap.from("#emotions-bar", {x: 1400, ease: "expo.out",delay:1});
    }, [currentChoice]);

    useEffect(() => {
        if (choiceReviewComplete) {
            gsap.from("#replacement-bar", {x: -1400, ease: "expo.out"});
        }
    }, [choiceReviewComplete])

    useEffect(() => {
        if(showTable){
            gsap.to(".thought-review-table",{opacity:1})
        }
    }, [showTable]);



    const advance = () => {
        if (choiceReviewComplete) {
            setCounter(counter + 1);
            setChoiceReviewComplete(false);
        } else if (showTable) {
            completed();
        } else {
            setChoiceReviewComplete(true);
        }
    }

    const getUnselected = () => {
        return _.filter(choices, (c) => {
            return selected.indexOf(c.id) === -1
        })
    }

    return (
        <div className="ThoughtDragReview">
            {showTable &&
            <div className="thought-review-table">
                <div className="thought-review-table-instrux">
                    Now take a look at the thoughts you didn't select. When you're ready, click CONTINUE.
                </div>
                <table>
                    <thead>
                    <tr>
                        <td className="yellow header">
                            thought
                        </td>
                        <td className="gray header">
                            emotions
                        </td>
                        <td className="blue header">
                            replacement thought
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    {choices &&
                    getUnselected().map((item, index) => (
                        <tr key={index}>
                            <td className="yellow">
                                {item.label}
                            </td>
                            <td className="gray">
                                {item.info}
                            </td>
                            <td className="blue">
                                {item.body}
                            </td>
                        </tr>
                    ))
                    }
                    </tbody>
                </table>
            </div>
            }
            {currentChoice &&
            <div className="thought-review-panel">
                <div className="thought-review-row thought"
                     id="thought-bar">
                    <div className="thought-review-title">
                        Thought
                    </div>
                    <div className="thought-review-body">
                        {currentChoice.label}
                    </div>
                </div>
                <div className="thought-review-row emotions"
                     id="emotions-bar">
                    <div className="thought-review-title">
                        Emotions
                    </div>
                    <div className="thought-review-body">
                        {currentChoice.info}
                    </div>
                </div>
                <div className={"thought-review-row replacement" + (choiceReviewComplete ? " visible" : " invisible")}
                     id="replacement-bar">
                    <div className="thought-review-title">
                        Replacement
                    </div>
                    <div className="thought-review-body">
                        {currentChoice.body}
                    </div>
                </div>

            </div>
            }
            <StandardButton data={"Continue"}
                            callback={advance}
                            style={{
                                "position": "absolute",
                                "right": 0,
                                "bottom": "50px"
                            }}/>
        </div>
    );
};

export default ThoughtDragReview;